// extracted by mini-css-extract-plugin
export var center = "_5w-2";
export var clickableRow = "_5w-5";
export var expandedRow = "_5w-7";
export var hoverable = "_5w-4";
export var left = "_5w-1";
export var right = "_5w-3";
export var row = "_5w-0";
export var selectedRow = "_5w-6";
export var summaryRow = "_5w-8";